import http from "@/common/http.service";
const ROOT_URL = "webform/search";
const DELETE_FORM = "form/";
const CLONE_FORM = "form/clone/";
const DEACTIVATE_URL = "form/inactivate/";
const ACTIVATE_URL = "form/publish/";
export default {
  fetchItems(params, cb) {
    http.post(ROOT_URL, params).then(function (response) {
      var data = {
        items: response.data.data,
        total: response.data.count,
        contactBalance: response.data.contactBalance,
      };
      cb(data);
    });
  },
  deleteForm(id) {
    return http.deleteRecord(DELETE_FORM + id);
  },
  cloneForm(id) {
    return http.patch(CLONE_FORM + id);
  },
  activate(id) {
    return http.patch(ACTIVATE_URL + id);
  },
  deactivate(id) {
    return http.get(DEACTIVATE_URL + id);
  },
};
